import React, {Component} from 'react';
import styled from 'styled-components';
import {bindActionCreators} from "redux";
import connect from "react-redux/es/connect/connect";
import {toJS} from "../../to-js";
import ProductCard from "../product/ProductCard";
import * as Actions from "../../actions/actions";
import Toggle from "../common/Toggle";
import RangeSlider from "../common/RangeSlider";
import H from "../typography/H";

const Column = styled.div`
  margin-top: 40px;
`;

const Header = styled.div`
  padding-top: 60px;
  padding-bottom: 40px;
  text-align: center;
`;

const Title = styled.div`
  color: ${p => p.theme.cTheme};
  margin-bottom: 10px;
`;

const Text = styled.div`
  max-width: 620px;
  margin: auto;
`;

const FilterWrapper = styled.div`
  background-color: #f8f8f8;
  margin-top: 30px;
  border: 1px solid ${p => p.theme.cBorderLight};
  border-left: none;
  border-right: none;
  padding: 20px 0 15px;
`;

const FilterTitle = styled.div`
  font-size: ${p => p.theme.sH4}px;
  font-weight: bold;
  text-align: center;
  margin-bottom: 15px;
`;

const FilterList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: baseline;
  justify-content: center;
  li{
    padding: 0 10px;
  }
  input{
    position: absolute;
    opacity: 0;
    pointer-events: none;
    height: 0;
    width: 0;
    visibility: hidden;
  }
`;

const FilterItem = styled.label`
  color: ${p => p.theme.cBorderLight};
  font-size: 55px;
  position: relative;
  cursor: pointer;
  margin-bottom: 0;
  input:checked + i{
    color: ${p => p.theme.cTheme};
  }
`;

class Row extends Component {

    filterProducts = (products) => {
        return [...products].filter((product) => {
            console.log(product.type, this.props.type);
            return product.type === this.props.type;
        });
    };

    sortProducts = (products) => {
        return products.sort((a, b) => {
            const targetWidth = this.props.widthValue;
            const targetHeight = this.props.heightValue;
            const deltaXA = Math.abs(a.size.x - targetWidth);
            const deltaXB = Math.abs(b.size.x - targetWidth);
            const deltaYA = Math.abs(a.size.y - targetHeight);
            const deltaYB = Math.abs(b.size.y - targetHeight);
            return (0.5 * (deltaXA - deltaXB)) + (0.5 * (deltaYA - deltaYB));
        });
    };

    handleTypeChange = (type) => {
        this.props.toggleFilterType(type);
    };

    render() {

        const filteredProducts = this.filterProducts(this.props.products);

        const sortedProducts = this.sortProducts(filteredProducts);

        const productsOnPage = sortedProducts.slice(
            this.props.productsPerPage * this.props.catalogPage,
            this.props.productsPerPage * this.props.catalogPage + this.props.productsPerPage,
        );

        const productsToRender = productsOnPage.map((product, key) => {
            return <Column key={key} className="col-lg-4 col-sm-6"><ProductCard outline product={product}/></Column>
        });

        const width = this.props.sliderParameters.width[this.props.type];
        const height = this.props.sliderParameters.height[this.props.type];
        const step = this.props.sliderParameters.step[this.props.type];

        return (
            <div className={this.props.className}>

                <div className="container">
                    <Header>
                        <Title><H size={2} styleSize={2}>Выберите свой размер</H></Title>
                        <Text><p>Помимо стандартных окон и дверей для типовых построек у нас имеется богатый ассортимент
                            продукции нестандартных размеров</p></Text>
                    </Header>
                    <div className="row">
                        <div className="col-md-4">
                            <Toggle flipped={!(this.props.type === 'windows')}
                                    callback={this.props.flipFilterSwitch}/>
                        </div>
                        <div className="col-md-4">
                            <RangeSlider value={this.props.widthValue}
                                         field={{min: width.min, max: width.max, step: step}}
                                         callback={(value) => {
                                             this.props.setDimensions({
                                                 param: 'width',
                                                 value: value,
                                             })
                                         }}/>
                        </div>
                        <div className="col-md-4">
                            <RangeSlider value={this.props.heightValue}
                                         field={{min: height.min, max: height.max, step: step}}
                                         callback={(value) => {
                                             this.props.setDimensions({
                                                 param: 'height',
                                                 value: value,
                                             })
                                         }}/>
                        </div>
                    </div>
                </div>
                <FilterWrapper>
                    <div className="container">
                        <FilterTitle>Отсортируйте по конструкции окна</FilterTitle>
                        <FilterList>
                            <li>
                                <FilterItem>
                                    <input checked={this.props.types.indexOf('single') !== -1} type="checkbox"
                                           onChange={(e) => this.handleTypeChange('single')}/>
                                    <i className="icon-window-single"/>
                                </FilterItem>
                            </li>
                            <li>
                                <FilterItem>
                                    <input checked={this.props.types.indexOf('double') !== -1} type="checkbox"
                                           onChange={(e) => this.handleTypeChange('double')}/>
                                    <i className="icon-window-double"/>
                                </FilterItem>
                            </li>
                            <li>
                                <FilterItem>
                                    <input checked={this.props.types.indexOf('triple') !== -1} type="checkbox"
                                           onChange={(e) => this.handleTypeChange('triple')}/>
                                    <i className="icon-window-triple"/>
                                </FilterItem>
                            </li>
                            <li>
                                <FilterItem>
                                    <input checked={this.props.types.indexOf('doubleT') !== -1} type="checkbox"
                                           onChange={(e) => this.handleTypeChange('doubleT')}/>
                                    <i className="icon-window-doubleT"/>
                                </FilterItem>
                            </li>
                            <li>
                                <FilterItem>
                                    <input checked={this.props.types.indexOf('tripleT') !== -1} type="checkbox"
                                           onChange={(e) => this.handleTypeChange('tripleT')}/>
                                    <i className="icon-window-tripleT"/>
                                </FilterItem>
                            </li>
                        </FilterList>
                    </div>
                </FilterWrapper>
                <div className="container">
                    <div className="row">
                        {productsToRender}
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const type = state.getIn(['filter', 'type']);
    const products = state.get('products');
    return {
        type: type,
        types: state.getIn(['filter', 'types']),
        widthValue: state.getIn(['filter', 'sliderValues', 'width', type]),
        heightValue: state.getIn(['filter', 'sliderValues', 'height', type]),
        sliderParameters: state.getIn(['filter', 'sliderParameters']),
        products: products,
        productsPerPage: state.getIn(['state', 'productsPerPage']),
        catalogPage: state.getIn(['state', 'catalogPage']),
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        flipFilterSwitch: Actions.flipFilterSwitch,
        setDimensions: Actions.setDimensions,
        toggleFilterType: Actions.toggleFilterType,
    }, dispatch)
}


export default connect(mapStateToProps, mapDispatchToProps)(toJS(styled(Row)`
  margin-bottom: 40px;
`));